import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {
    private rootUrl: string = "/api/agencies";

    constructor(private httpClient: HttpClient) { }

    public getAgencyName(id: number): Observable<string> {
        const url = this.rootUrl + "/" + id + "/name";
      return this.httpClient.get(url, { responseType: 'text' });
    }
}
